// @ts-nocheck TODO: type issues need to be fixed in this file
import _ from 'lodash';

export const isUserAuthenticated = (state) =>
  _.get(state, ['auth', 'authenticated'], false);
